// extracted by mini-css-extract-plugin
export default {"cls1":"UqfTTv33IHjLXxd12Mn2","cls2":"SPQSiMLmUvZLk4uyM0I9 UqfTTv33IHjLXxd12Mn2","isPhone":"ps3KvjvUH7uNwDUT2Smd"};